export default function PlayIcon() {
    return (
        <svg
            width="40"
            height="46"
            viewBox="0 0 40 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M37.9141 19.5359C40.5807 21.0755 40.5807 24.9245 37.9141 26.4641L6.54449 44.5753C3.87783 46.1149 0.544492 44.1904 0.544493 41.1112L0.544494 4.88873C0.544494 1.80953 3.87783 -0.114973 6.54449 1.42463L37.9141 19.5359Z"
                fill="white"
            />
        </svg>
    );
}
